import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/features/recognition',
    name: 'Features-Recognintion',
    component: () => import('../views/Recognition.vue')
  },
  {
    path: '/features/rewards',
    name: 'Features-Rewards',
    component: () => import('../views/Rewards.vue')
  },
  {
    path: '/features/trees',
    name: 'Features-Trees',
    component: () => import('../views/Trees.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('../views/Pricing.vue')
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import('../views/Partners.vue'),
    solidNav: true,
  },
  {
    path: '/resources/blog',
    name: 'Resources-Blog',
    component: () => import('../views/Blog.vue')
  },
  {
    path: '/resources/blog/:slug',
    name: 'Resources-Blog-Post',
    component: () => import('../views/BlogPost.vue')
  },
  {
    path: '/resources/library',
    name: 'Resources-Library',
    component: () => import('../views/Library.vue')
  },
  {
    path: '/resources/news',
    name: 'Resources-News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/book-a-demo',
    name: 'Book-A-Demo',
    component: () => import('../views/BookADemo.vue')
  },
  {
    path: '/app-login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/privacy-notice',
    name: 'Privacy-notice',
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms-and-conditions',
    component: () => import('../views/Terms.vue')
  },
  {
    path: '/privacy-notice-fr',
    name: 'Privacy-notice-FR',
    component: () => import('../views/PrivacyFr.vue')
  },
  {
    path: '/terms-and-conditions-fr',
    name: 'Terms-and-conditions-FR',
    component: () => import('../views/TermsFr.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 250)
    })
  }
  
})

export default router
